import { apiClient } from './api';
import type { ApiResponse } from '../types/api.types';

export interface UserNotice {
  id: string;
  kind: string;
  title: string;
  body: string;
  link: string | null;
  created_at: string;
  read_at: string | null;
}

/** The signed-in person's own notices (the bell), newest first, with how many are unread. */
export async function getMyNotices(): Promise<{ notices: UserNotice[]; unread: number }> {
  const { data } = await apiClient.get<ApiResponse<{ notices: UserNotice[]; unread: number }>>('/api/notices');
  return data.data ?? { notices: [], unread: 0 };
}

export async function markNoticeRead(id: string): Promise<void> {
  await apiClient.post(`/api/notices/${id}/read`);
}

export async function markAllNoticesRead(): Promise<void> {
  await apiClient.post('/api/notices/read-all');
}
